import { LOCATION_CHANGED } from '../../../actions/location';
import { getInitialLocation } from '../initialLocation';

import type { Action } from '@web-platform/shared-universal-types/src/redux/actions/actions-shared-types';
import type { LocationState } from '@web-platform/shared-universal-types/src/redux/state/appInitial/location';

export default function (
  state: LocationState = getInitialLocation(),
  action: Action,
): LocationState {
  switch (action.type) {
    case LOCATION_CHANGED:
      return {
        ...action.payload.location,
        lastNavWasSoft: true,
        virtualReferrer: action.payload.referrer,
      };

    default:
      return state;
  }
}
export const get = (state: LocationState): LocationState => state;
